import FleetManagementContainer from '../FleetManagement/Container'

export default function ZoneFleetManagement({ selectedZone }) {
  return <FleetManagementContainer selectedZone={selectedZone} />
}
